import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const phone = settings?.phone || "240-383-9887";
  const company = settings?.company_name || "B&J Electric Service LLC";

  return (
    <footer className="bg-[#050505] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-md bg-yellow-400 flex items-center justify-center">
                <Zap className="w-4.5 h-4.5 text-black" strokeWidth={2.5} />
              </div>
              <span className="font-display font-bold text-white text-lg tracking-tight">{company}</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Licensed & insured electricians proudly serving the DMV since 2009.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-white/40 font-bold mb-4">Quick Links</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#services" className="text-white/70 hover:text-yellow-400 transition-colors">Services</a></li>
              <li><a href="#about" className="text-white/70 hover:text-yellow-400 transition-colors">About Us</a></li>
              <li><a href="#quote" className="text-white/70 hover:text-yellow-400 transition-colors">Get a Quote</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-yellow-400 transition-colors">Contact</a></li>
              <li>
                <Link
                  to="/admin/login"
                  data-testid="footer-admin-link"
                  className="text-white/40 hover:text-yellow-400 transition-colors"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-white/40 font-bold mb-4">Contact</div>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`tel:${phone.replace(/[^0-9]/g, "")}`}
                  data-testid="footer-phone"
                  className="text-yellow-400 font-semibold hover:underline"
                >
                  {phone}
                </a>
              </li>
              <li className="text-white/60">{settings?.email || "bjelectricservice@gmail.com"}</li>
              <li className="text-white/60">{settings?.service_area || "DC • MD • VA (DMV)"}</li>
              <li className="text-white/60">{settings?.hours || "Mon–Sat: 7AM–7PM"}</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-white/40 text-xs">
            © {new Date().getFullYear()} {company}. All rights reserved.
          </div>
          <div className="text-white/40 text-xs">Licensed & Insured • DMV Area</div>
        </div>
      </div>
    </footer>
  );
}
